/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Lots_TitleInputs */

const vi_scl_lots_title = /** @type {(inputs: Scl_Lots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách lô lấy hương`)
};

/**

* @param {Scl_Lots_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_lots_title = /** @type {((inputs?: Scl_Lots_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Lots_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_lots_title(inputs)
});